import React, { useState, useEffect, useContext, useSyncExternalStore } from "react";
import { Table } from "flowbite-react";
import { FaArrowRightLong } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context";
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import Loader from "../Loader/Loader";

const Modal = ({ isModalOpen, setIsModalOpen, denominationItem, setDenominationItem, handleSubmitDenomination }) => {
    //   // Only render the modal if isOpen is true
    if (!isModalOpen) return null;

    return (
        <>
            {/* Modal Overlay */}
            <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
                {/* Modal Content */}
                <div className="bg-white rounded-lg w-full sm:w-96 p-6 mx-4 sm:mx-auto shadow-lg relative">
                    {/* Close Icon at top-right corner */}
                    <button
                        onClick={() => setIsModalOpen(val => !val)}
                        className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 focus:outline-none"
                    >
                        <FaTimes className="text-2xl" />
                    </button>

                    <h1 className="text-2xl font-semibold text-gray-800 mb-4"><span className='text-lg font-thin'>Currency :</span>&nbsp;&nbsp;{denominationItem.currency}</h1>
                    {/* <h2 className="text-xl font-medium text-gray-600 mb-4"><span className='text-lg font-thin'>Currency :</span>&nbsp;&nbsp;{denominationItem.country}</h2> */}

                    <form onSubmit={handleSubmitDenomination}>
                        <div className="mb-4">
                            <label htmlFor="inputField" className="block text-lg text-gray-700 mb-2">Denomination Value </label>
                            <input
                                onChange={(e) => setDenominationItem({
                                    ...denominationItem, denomination: e.target.value
                                })}
                                type="text"
                                id="inputField"
                                defaultValue={denominationItem.denomination}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:ring-2 focus:ring-blue-600 focus:outline-none"
                                placeholder="Enter Denomination Value"
                            />
                        </div>

                        {/* Submit Button at the bottom */}
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                className="px-6 py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 transition-all"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

const ForeignCurrencyPage = () => {

    const navigate = useNavigate();

    const { state } = useContext(UserContext);

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const { currency } = useParams();
    const { country } = useParams();


    const [rows, setRows] = useState([]);
    const [grandTotal, setGrandTotal] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [denominationItem, setDenominationItem] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const getBalance = async () => {
        setIsLoading(true);
        const balance = await axios.get(process.env.REACT_APP_API_URL + 'getForeignCurrencyBalance', {
            params: { currency: currency, shopId: userDetail?.shopId },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setIsLoading(false);

        // console.log('balanceData: ', balance.data)
        if (balance.data.length) {
            setRows(balance.data);
        }
    }
    useEffect(() => {
        getBalance();
    }, []);

    // Calculate grand total on initial render and update state
    useEffect(() => {
        const initialTotal = rows.reduce((acc, row) => acc + row.total, 0);
        setGrandTotal(initialTotal);
    }, [rows]);

    const handleInputChange = (index, inputIndex, value) => {
        setRows((prevRows) =>
            prevRows.map((row, rowId) => {
                if (rowId === index) {
                    const updatedRow = { ...row, [`${inputIndex}`]: value };

                    // Calculate total
                    updatedRow.total =
                        updatedRow.looseQuantity * updatedRow.denomination +
                        updatedRow.bulkQuantity * 10 * updatedRow.denomination;

                    // Re-calculate grand total based on the updated row
                    const newGrandTotal = prevRows
                        .map((row) => row === updatedRow ? updatedRow.total : row.total)
                        .reduce((acc, row) => acc + row, 0);

                    setGrandTotal(newGrandTotal);

                    return updatedRow;
                } else {
                    return row;
                }
            })
        );
    };

    const handleUpdate = async (req, res) => {
        try {
            setIsLoading(true)
            await axios.post(`${process.env.REACT_APP_API_URL}/updateForeignCurrencyBalance`, rows, {
                params: {
                    shopId: userDetail?.shopId,
                },
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            toast.success('Success: Balance updated.');
            navigate("/foreign-currency-balance");
            setIsLoading(false)
        } catch (error) {
            toast.error('Error: Balance not updated.');
            setIsLoading(false)
        }
    };

    const handleAddDenomination = () => {
        setDenominationItem({
            ...denominationItem, currency: currency
        })
        setIsModalOpen(val => !val)
    }

    const handleSubmitDenomination = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true)
            const response = await axios.post(process.env.REACT_APP_API_URL + 'addDenomination', denominationItem, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.status === 200) {
                setIsModalOpen(val => !val)
                toast.success('Denomination Created Successfully.');
                // const currency = `${denominationCurrency}, ${denominationCountry}`
                await getBalance();
                // await handleChangeDenomination(currency);
                setDenominationItem({});
                // setDenominationCurrency('');
                // setDenominationCountry('');
            }
            setIsLoading(false)

        } catch (error) {
            toast.error('Error: Denomination Not Created.');
            setIsLoading(false)
        }
    }

    return (
        <div className="">
            {isLoading? <Loader />: ''}
            <div className="">
                {/* <h1 className="text-headings text-3xl font-medium mt-[-36px] flex">Foreign Currency Balance - {currency} <FaArrowRightLong className="mx-3 mt-1" /> {country}</h1> */}
            </div>
            <div className="overflow-x-auto mt-12">
                <div className="flex justify-end px-5 pb-5">
                    <span className="text-lg align-middle font-medium mr-5">Total:</span>
                    <div className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-4 py-3 text-lg">{grandTotal}/-</div>
                </div>
                {rows.length > 0 ? (
                    <div>
                        <Table>
                            <Table.Head>
                                <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Sr #</Table.HeadCell>
                                <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Balance Inquiry</Table.HeadCell>
                                <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Loose Quantity</Table.HeadCell>
                                <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Bulk Quantity</Table.HeadCell>
                                <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Denomination</Table.HeadCell>
                                <Table.HeadCell className='bg-theme-secondary text-white font-medium text-lg'>Total</Table.HeadCell>
                            </Table.Head>
                            <Table.Body>
                                {rows.map((row, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell>
                                            &nbsp;&nbsp;&nbsp;&nbsp;{index + 1}
                                        </Table.Cell>
                                        <Table.Cell className="flex">
                                            &nbsp;&nbsp;&nbsp;&nbsp;{currency} <FaArrowRightLong className="mx-1 mt-1" /> {country}
                                        </Table.Cell>
                                        <Table.Cell>
                                            &nbsp;&nbsp;&nbsp;&nbsp;<input
                                                type="number"
                                                onChange={(e) => e.target.value >= 0 && handleInputChange(index, 'looseQuantity', e.target.value)}
                                                value={row.looseQuantity}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            &nbsp;&nbsp;&nbsp;&nbsp;<input
                                                type="number"
                                                value={row.bulkQuantity}
                                                onChange={(e) => e.target.value >= 0 && handleInputChange(index, 'bulkQuantity', e.target.value)}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{row.denomination}</Table.Cell>
                                        <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;{row.total}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </div>
                ) : (
                    <div>
                        <h1 className="text-3xl font-semibold text-gray-500 text-center mt-10">
                            No Denominations
                        </h1>
                    </div>
                )}

                {
                    rows.length > 0 ? (
                        <div>
                            <button className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-4 py-3 text-lg mt-4" onClick={handleUpdate}>Update Balance</button>
                        </div>
                    ) : (
                        <div>
                            {/* <button className="bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-4 py-3 text-lg mt-4" onClick={() => handleAddDenomination()}>Add Denomination</button> */}
                            {/* <Modal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} denominationItem={denominationItem} setDenominationItem={setDenominationItem} handleSubmitDenomination={handleSubmitDenomination} /> */}

                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default ForeignCurrencyPage;